/* eslint-disable @typescript-eslint/no-explicit-any */
/**
 * @desc 列举指定目录下的所有文件
 */
import { defaultSuccess, defaultError, http } from "@/plugins/axios";

export class GetAllFileNameByDirParams {
  constructor(public dirPath: string) {}
}

export default async function (
  params: GetAllFileNameByDirParams,
  success: ({
    data,
    ext,
    state,
    errors,
  }: {
    data: Array<string>;
    ext: ObjectMap;
    state: "SUCCESS" | "FAIL" | "EXCEPTION";
    errors?: Array<string>;
  }) => void = defaultSuccess,
  fail: (error: string) => void = defaultError
): Promise<void> {
  return http({
    method: "get",
    url: `/oss/fileName/directory`,

    params,
  })
    .then((data) => success(data as any))
    .catch((error) => fail(error));
}
